import { chakraCreateIcon as createIcon } from "@airhelp/react-ui-components";

export const Stars = createIcon({
  displayName: "trustpilotStars",
  viewBox: "0 0 109 22",
  defaultProps: {
    width: "109",
    height: "22",
  },
  path: (
    <>
      <path d="M20.7441 0.918457H0.423828V21.0812H20.7441V0.918457Z" fill="#00B67A" />
      <path d="M42.7568 0.918457H22.4365V21.0812H42.7568V0.918457Z" fill="#00B67A" />
      <path d="M64.7715 0.918457H44.4512V21.0812H64.7715V0.918457Z" fill="#00B67A" />
      <path d="M86.7842 0.918457H66.4639V21.0812H86.7842V0.918457Z" fill="#00B67A" />
      <path d="M108.799 0.918457H98.6387V21.0812H108.799V0.918457Z" fill="#DCDCE6" />
      <path d="M98.6387 0.918457H88.4785V21.0812H98.6387V0.918457Z" fill="#00B67A" />
      <path
        d="M10.5848 14.5073L13.6751 13.7302L14.9663 17.6788L10.5848 14.5073ZM17.6969 9.40363H12.257L10.5848 4.32092L8.91257 9.40363H3.47266L7.87539 12.5541L6.2032 17.6368L10.6059 14.4863L13.3153 12.5541L17.6969 9.40363Z"
        fill="white"
      />
      <path
        d="M32.5975 14.5073L35.6878 13.7302L36.979 17.6788L32.5975 14.5073ZM39.7096 9.40363H34.2697L32.5975 4.32092L30.9253 9.40363H25.4854L29.8881 12.5541L28.2159 17.6368L32.6186 14.4863L35.328 12.5541L39.7096 9.40363Z"
        fill="white"
      />
      <path
        d="M54.6121 14.5073L57.7025 13.7302L58.9937 17.6788L54.6121 14.5073ZM61.7242 9.40363H56.2843L54.6121 4.32092L52.9399 9.40363H47.5L51.9027 12.5541L50.2305 17.6368L54.6333 14.4863L57.3427 12.5541L61.7242 9.40363Z"
        fill="white"
      />
      <path
        d="M76.6258 14.5073L79.7162 13.7302L81.0074 17.6788L76.6258 14.5073ZM83.7379 9.40363H78.298L76.6258 4.32092L74.9536 9.40363H69.5137L73.9164 12.5541L72.2442 17.6368L76.6469 14.4863L79.3563 12.5541L83.7379 9.40363Z"
        fill="white"
      />
      <path
        d="M98.6404 14.5073L101.731 13.7302L103.022 17.6788L98.6404 14.5073ZM105.753 9.40363H100.313L98.6404 4.32092L96.9682 9.40363H91.5283L95.9311 12.5541L94.2589 17.6368L98.6616 14.4863L101.371 12.5541L105.753 9.40363Z"
        fill="white"
      />
    </>
  ),
});
